<template>
  <div>
    <div class="swiper-container-box pc-swiper">
      <div class="teacher fbox fbox-ac fbox-w">
        <div class="img-box">
          <div @click="toTeacher(sliders[currentIndex].objectId)" class="img cup" :style="{background: `url('${sliders[currentIndex].picture}') no-repeat center center`, backgroundSize: '100% 100%'}"></div>
        </div>
        <!-- <div @click="toTeacher(sliders[currentIndex].objectId)" class="img cup" :style="{background: `url('${sliders[currentIndex].picture}') no-repeat center center`, backgroundSize: '100% 100%'}"></div> -->
        <div class="teacher-info fg1">
          <div class="font-weight-b f46 ell">{{sliders[currentIndex].name}}<span class="f24 ml20">{{sliders[currentIndex].job}}</span></div>
          <div class="lable-contener fbox" v-if="sliders[currentIndex].lable.length">
            <div v-for="(lable, index) in sliders[currentIndex].lable" :key='index'>
              <p class="f16 mr20 ell_2">{{lable}}</p>
            </div>
          </div>
          <ul>
            <li v-for="(honor,index) in sliders[currentIndex].honor" :key='index'>
              <div class="ell_2">{{honor}}</div>
            </li>
          </ul>
        </div>
      </div>
      <!-- // 左右切换按钮 -->
      <div class="swiper-button-prevs"></div>
      <div class="swiper-button-nexts"></div>
    </div>
    <div class="pc-swiper gd_swiper-container m-t-30">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in sliders" :key="index" class="swiper-slide">
          <img :src="item.img" class="cup" :data-name="item.objectId">
        </div>
      </div>
    </div>
    <div class="ph-swiper">
      <div class="ph_swiper-container m-t-30">
        <div class="swiper-wrapper">
          <div v-for="(item, index) in sliders" :key="index" class="swiper-slide">
            <div class="ph-teacher">
              <div class="img-box">
                <div :data-name="item.objectId" class="img cup" :style="{background: `url('${item.picture}') no-repeat center center`, backgroundSize: '100% 100%'}"></div>
              </div>
              <div class="teacher-info tc p-t-30">
                <div class="font-weight-b f16 ell">{{item.name}}</div>
                <div class="f12 m-t-8 m-b-15">{{item.job}}</div>
                <div class="lable-contener fbox fbox-ac fbox-jc tl" v-if="item.lable.length">
                  <div v-for="(lable, index) in item.lable" :key='index'>
                    <p class="f16 mr20 ell_2">{{lable}}</p>
                  </div>
                </div>
                <ul class="tl">
                  <li v-for="(honor,index) in item.honor" :key='index'>
                    <div class="f16 ell_2">{{honor}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div><!--分页器。如果放置在swiper-container外面，需要自定义样式。-->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  name: 'dataCenter',
  props: {
    sliders: {
      type: Array
    }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  watch: {
    currentIndex () {
    }
  },
  created () {
  },
  mounted () {
    let that = this
    setTimeout(() => {
      var mySwiper = new Swiper('.gd_swiper-container', {
        loop: true,
        autoplay: {
          delay: 15000 // 10秒切换一次
        },
        navigation: {
          nextEl: '.swiper-button-nexts',
          prevEl: '.swiper-button-prevs'
        },

        on: {
          slideChangeTransitionEnd: function () {
            that.currentIndex = this.realIndex
          },
          click: function (e) {
            that.toTeacher(e.target.getAttribute('data-name'))
          }
        },
        slidesPerView: 6
      })
      var mySwiper = new Swiper('.ph_swiper-container', {
        loop: true,
        autoplay: {
          delay: 10000 // 10秒切换一次
        },
        pagination: {
          el: '.swiper-pagination'
        },
        on: {
          click: function (e) {
            that.toTeacher(e.target.getAttribute('data-name'))
          }
        },
        slidesPerView: 1
      })
    }, 500)
  },
  methods: {
    toTeacher (id) {
      this.$push({
        path: '/teacherDetail',
        query: {
          id
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.gd_swiper-container{
  overflow: hidden;
}
.ph_swiper-container{
  overflow: hidden;
  position: relative;

}
.ph-swiper{
  position: relative;
  width: 100%;
  display: none;
  ::v-deep{
    .swiper-pagination-bullets{
      width: 100%;
      margin: 0 auto;
      bottom: -10px !important;
    }
    .swiper-pagination-bullet{
      margin: 0 6px;
    }
    .swiper-pagination-bullet-active{
      background-color: #01C387;
    }
  }
}
.swiper-container-box {
  width: 100%;
  padding-top: 100px;
  position: relative;
  ::v-deep {
    .swiper-slide {
      // width: 142px !important;
      width: 220px;
      height: 146px;
    }
    .swiper-wrapper {
      // padding: 0 80px;
      box-sizing: border-box;
    }
    .swiper-button-prevs {
      background-image: url("https://qingbo-oss.oss-cn-beijing.aliyuncs.com/1fd6a5c5-dcac-41ee-be29-2af9c944ca42.png");
      background-position: center center;
      background-size: 10px 18px;
      outline: none;
      width: 52px;
      height: 51px;
      background-color: #eef0f5;
      border-radius: 6px 0px 0px 6px;
      position: absolute;
      left: auto;
      right: 0 !important;
      top: 75%;
      &:hover {
        background-image: url("https://qingbo-oss.oss-cn-beijing.aliyuncs.com/da2a2901-f329-4d41-82c7-4625d7f0e6de.png");
        background-color: #4ec490;
      }
    }
    .swiper-button-nexts {
      background-image: url("https://qingbo-oss.oss-cn-beijing.aliyuncs.com/57d26e26-11d9-4fd3-824b-31973036a571.png");
      background-position: center center;
      background-size: 10px 18px;
      outline: none;
      width: 52px;
      height: 51px;
      background-color: #eef0f5;
      border-radius: 0px 6px 6px 0px;
      position: absolute;
      top: 75%;
      right: -52px;
      &:hover {
        background-image: url("https://qingbo-oss.oss-cn-beijing.aliyuncs.com/482a3b44-82fc-4dbf-aaab-3ce0ef89d3c7.png");
        background-color: #4ec490;
      }
    }
  }
}

// 老师简介
.teacher {
  width: 100%;
  // height: 482px;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
  box-sizing: border-box;
  .img-box{
    width: 439px;
    height: 529px;
    .img {
      width: 439px;
      height: 529px;
      border-radius: 20px;
      position: absolute;
      left: 40px;
      top: -87px;
    }
  }
  .teacher-info {
    // margin-left: 40rem;
    margin-left: 10%;
    & > div {
      margin-bottom: 40px;
    }
    ul {
      min-height: 150px;
      li {
        div {
          font-size: 18px;
          color: #83869f;
          box-sizing: border-box;
          position: relative;
          padding: 15px 0 15px 25px;
          &:nth-child(1) {
            margin-top: 0;
          }
          &::before {
            content: "";
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-left: 15px solid #f6cba0;
            border-bottom: 8px solid transparent;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
}
.ph-teacher{
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
  box-sizing: border-box;
  .img-box{
    width: 125px;
    height: 151px;
    border-radius: 20px;
    margin: 0 auto;
    .img {
      width: 100%;
      height: 100%;
    }
  }
  .teacher-info {
    ul {
      min-height: 150px;
      padding: 0 50px;
      box-sizing: border-box;
      li {
        padding: 20px 0;
        div {
          font-size: 18px;
          color: #83869f;
          box-sizing: border-box;
          position: relative;
          padding: 0px 0 0px 25px;
          &:nth-child(1) {
            margin-top: 0;
          }
          &::before {
            content: "";
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-left: 15px solid #f6cba0;
            border-bottom: 8px solid transparent;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
}

.lable-contener {
  p {
    font-size: 20px;
    color: #ac754b;
    padding: 3px 15px 2px;
    background: linear-gradient(133deg, #fee0cc 0%, #f8d5b2 100%);
    border-radius: 0px 20px 20px 20px;
  }
}
.cup {
  width: 220px;
  height: 146px;
  cursor: pointer;
}
@media(max-width: 992px) {
  .pc-swiper,.swiper-button-prevs,.swiper-button-nexts{
    display: none;
  }
  .ph-swiper{
    display: block;
  }
  .ph-teacher{
    padding-top: 20px;
  }
  .f16{
    font-size: 14px !important;
  }
}
</style>
